import routes from "./router/routes"
import taskStore from "./store/task-store"
import taskEventBus from "./events/event-bus"

export function taskModule({ store, router, eventBus }) {
  for (const route of routes) router.addRoute("dashboard", route)
  store.registerModule("tasks", taskStore)
  taskEventBus.init(eventBus)
}
